// ONLY runs on collection/listing pages. Finds product cards titled
// "Pick Any N" and multiplies that card's own displayed price by N, so
// the card shows the full combo total instead of the per-piece price.
// Deliberately does nothing on product pages (the combo-builder block
// there already computes and shows the correct total itself - running
// this there would double-multiply it).
(function () {
  // Hard guard: collection pages only.
  if (window.location.pathname.indexOf('/collections/') !== 0) return;

  function formatMoney(amount) {
    return amount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function findLeafElements(root) {
    return Array.prototype.filter.call(root.querySelectorAll('*'), function (el) {
      return el.children.length === 0 && el.textContent.trim().length > 0;
    });
  }

  function updateComboPrices() {
    // Each product card is reliably wrapped in its own single
    // <a href="/products/..."> link - scope everything to that boundary
    // (and a couple of parent levels above it, since price/swatches often
    // sit as siblings outside the link, not nested inside it) so cards
    // never bleed into each other.
    var cardLinks = document.querySelectorAll('a[href*="/products/"]');

    cardLinks.forEach(function (card) {
      if (card.dataset.comboCardChecked) return;

      var titleEl = null;
      var titleLeaves = findLeafElements(card);
      for (var i = 0; i < titleLeaves.length; i++) {
        if (/Pick\s+Any\s+\d+/i.test(titleLeaves[i].textContent)) {
          titleEl = titleLeaves[i];
          break;
        }
      }
      if (!titleEl) return;

      var match = titleEl.textContent.match(/Pick\s+Any\s+(\d+)/i);
      if (!match) return;
      var pickCount = parseInt(match[1], 10);
      if (!pickCount || pickCount < 2) return;

      // Try the anchor itself first, then walk up up to 2 more parent
      // levels looking for the price - stop at the first scope where a
      // price is found, so we never reach far enough to hit a sibling
      // card's price.
      var scopes = [card];
      if (card.parentElement) scopes.push(card.parentElement);
      if (card.parentElement && card.parentElement.parentElement) {
        scopes.push(card.parentElement.parentElement);
      }

      var priceEl = null;
      for (var s = 0; s < scopes.length && !priceEl; s++) {
        var leaves = findLeafElements(scopes[s]);
        for (var j = 0; j < leaves.length; j++) {
          var el = leaves[j];
          if (el === titleEl || el.dataset.comboPriceUpdated) continue;
          if (/(₹|Rs\.?)\s?[\d,]+(\.\d+)?/.test(el.textContent)) {
            priceEl = el;
            break;
          }
        }
      }
      if (!priceEl) return;

      var priceMatch = priceEl.textContent.match(/[\d,]+(\.\d+)?/);
      if (!priceMatch) return;
      var base = parseFloat(priceMatch[0].replace(/,/g, ''));
      if (isNaN(base)) return;

      var total = base * pickCount;
      priceEl.textContent = priceEl.textContent.replace(priceMatch[0], formatMoney(total));
      priceEl.dataset.comboPriceUpdated = '1';
      card.dataset.comboCardChecked = '1';
    });
  }

  var debounceTimer = null;
  function schedule() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updateComboPrices, 300);
  }

  document.addEventListener('DOMContentLoaded', schedule);
  var observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true });
})();